import React from "react";
import "./App.scss";
import Main from "./components/Main";

import { _common } from "./common";
import MainAnzeigeTafel2 from "./components/MainAnzeigeTafel2";
const common = _common;

//
// Stand M&M 21.3.2025
//

function App() {
  let style: any | undefined;
  if (common.anzeigeTafelMode) {
    style = {
      overflow: "hidden",
      width: "100vw",
      height: "100vh",
    };
  }
  return (
    <div className="App" style={style}>
      {common.anzeigeTafelMode && <MainAnzeigeTafel2 />}
      {!common.anzeigeTafelMode && <Main />}
    </div>
  );
}

export default App;
